
import { defineComponent, PropType } from 'vue';
import { ElCarousel, ElCarouselItem } from 'element-plus';

export default defineComponent({
    components: {
        ElCarousel,
        ElCarouselItem
    },
    props: {
        images: {
            type: Array as PropType<{resource_url:string}[]>,
            default: () => {
                return [];
            }
        }
    }
});
